import { ROUTES } from '../../constants/routes';

/**
 * Root breadcrumb for authenticated app pages.
 * Always links to the dashboard hub — never use "Home" or legacy /r/home paths.
 */
export const DASHBOARD_BREADCRUMB = Object.freeze({
  label: 'Dashboard',
  href: ROUTES.DASHBOARD.HUB,
});

/**
 * @typedef {Object} BreadcrumbSegment
 * @property {string|React.ReactNode} label
 * @property {string} [href]
 * @property {(event: React.MouseEvent) => void} [onClick]
 */

/**
 * Builds a breadcrumb trail with Dashboard as the first segment.
 *
 * @param {BreadcrumbSegment[]} segments - Middle and terminal crumbs (last = current page)
 * @returns {BreadcrumbSegment[]}
 */
export function buildBreadcrumbs(segments = []) {
  return [DASHBOARD_BREADCRUMB, ...segments];
}

/**
 * Standard click handler for DynamicBreadcrumbs — supports href and onClick segments.
 *
 * @param {import('react-router-dom').NavigateFunction} navigate
 */
export function createBreadcrumbNavigateHandler(navigate) {
  return (_event, item) => {
    if (item?.onClick) {
      item.onClick(_event);
      return;
    }
    if (item?.href) {
      navigate(item.href);
    }
  };
}
